/**
 * Fake providers can be added here, (which will trigger the generic modal).
 *
 * @note The icon for a provider will follow the pattern of
 * {slug}.png, ex: fakeprovider.png. Icons will need to be
 * created and added as well. (Or icon will fallback to archie icon)
 */
export const fakeProviders = [
	// {
	// 	name       : 'Fake Provider',
	// 	slug       : 'fakeprovider',
	// 	categories : [ 'crm' ],
	// },
]
